import { ArrowRight, PhoneCall } from 'lucide-react';
import Container from '../ui/Container';
import Reveal from '../ui/Reveal';
import Button from '../ui/Button';
import { slaCommitments } from '../../data/process';
import { site } from '../../data/site';

/** Closing conversion block used at the bottom of most pages. */
export default function CtaBanner() {
  return (
    <section className="relative overflow-hidden bg-brand-800 py-20 sm:py-24">
      <div className="pointer-events-none absolute inset-0 bg-grid bg-grid-cell opacity-50" aria-hidden="true" />
      <div
        className="pointer-events-none absolute -right-24 -top-24 h-96 w-96 rounded-full bg-brand-400/20 blur-[110px]"
        aria-hidden="true"
      />

      <Container className="relative">
        <Reveal className="text-center">
          <span className="eyebrow-dark">Get started</span>
          <h2 className="mx-auto mt-6 max-w-3xl text-3xl font-bold leading-tight tracking-tight text-white sm:text-4xl lg:text-[2.75rem]">
            Book a pickup today, close your compliance file this month
          </h2>
          <p className="mx-auto mt-5 max-w-2xl text-base leading-relaxed text-brand-100/85">
            Share your inventory and we will return a quotation within 24 hours, collect within 48 working
            hours and deliver your full documentation set within a week.
          </p>

          <div className="mt-9 flex flex-wrap justify-center gap-3">
            <Button to="/request-pickup" variant="light" size="lg">
              Request a Pickup
              <ArrowRight className="h-4 w-4" />
            </Button>
            <Button href={`tel:${site.phone.replace(/\s/g, '')}`} variant="onDark" size="lg">
              <PhoneCall className="h-4 w-4" />
              {site.phone}
            </Button>
          </div>
        </Reveal>

        <Reveal
          delay={0.12}
          className="mt-14 grid gap-px overflow-hidden rounded-xl2 border border-white/10 bg-white/10 sm:grid-cols-3"
        >
          {slaCommitments.map((sla) => (
            <div key={sla.label} className="bg-brand-800 px-6 py-6 text-center">
              <p className="font-display text-xl font-bold text-white">{sla.value}</p>
              <p className="mt-1.5 text-xs font-medium uppercase tracking-wider text-brand-200/80">
                {sla.label}
              </p>
            </div>
          ))}
        </Reveal>
      </Container>
    </section>
  );
}
